var __jsx = React.createElement;
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useQuery } from '@apollo/client';
import { ItemIcon, ItemText, Item, StyledLink } from './style';
import { GET_SIDEBAR_STATUS } from '../../../../../apollo/queries';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SidebarItem = function SidebarItem(_ref) {
  var text = _ref.text,
    icon = _ref.icon,
    link = _ref.link;
  var _useQuery = useQuery(GET_SIDEBAR_STATUS),
    client = _useQuery.client;
  var toggleSidebar = function toggleSidebar() {
    client.writeQuery({
      query: GET_SIDEBAR_STATUS,
      data: {
        sidebarOpen: false
      }
    });
  };
  return /*#__PURE__*/_jsx(StyledLink, {
    href: link,
    onClick: toggleSidebar,
    children: /*#__PURE__*/_jsxs(Item, {
      button: true,
      children: [/*#__PURE__*/_jsx(ItemIcon, {
        children: icon
      }), /*#__PURE__*/_jsx(ItemText, {
        primary: text
      })]
    }, text)
  });
};
export default SidebarItem;